import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { assignInstallerToBusinessAndStore } from 'api/admin/users/users';
import { UserTypes } from 'constants/constants';
import { ApiError } from 'types/api';

export interface GetLightweightStoresForBusinessOutput {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  password: string;
  roles: Array<{
    userType: UserTypes;
  }>;
  business: {
    id: number;
    name: string;
  };
  teamMember: null;
  installerStore: {
    id: number;
    name: string;
  };
}

export interface AssignInstallerToBusinessAndStorePayload {
  userId: number;
  businessId: number | null;
  storeId: number | null;
}

export const useAssignInstallerToBusinessAndStore = () => {
  return useMutation<unknown, ApiError, AssignInstallerToBusinessAndStorePayload>({
    mutationFn: async ({ userId, businessId, storeId }) => {
      const { data } = (await assignInstallerToBusinessAndStore(userId, {
        businessId,
        storeId,
      })) as AxiosResponse<GetLightweightStoresForBusinessOutput>;

      return data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ??
          'An error occurred while assigning installer to the business and store',
        {
          duration: 4000,
        },
      );
    },
  });
};
